/**
 * Fil de messages entre la direction et un employé.
 *
 * Le fil voyageait avec la fiche et se réécrivait en entier à chaque
 * enregistrement, d'un côté comme de l'autre : l'écran resté sur un fil
 * périmé effaçait le dernier message de l'autre. Chaque message part
 * désormais seul au serveur, qui l'ajoute sans toucher au reste ; ces
 * quelques règles reportent ensuite la réponse dans la collection locale.
 */

/**
 * Ajoute au fil d'un employé le message que le serveur vient d'enregistrer.
 *
 * @param {Array} employes collection locale des fiches
 * @param {number} empId fiche concernée
 * @param {object} message message au format de l'interface
 * @returns {Array} la collection, la fiche mise à jour
 */
export function ajouteAuFil(employes, empId, message) {
  return (employes || []).map((e) =>
    e.id === empId ? { ...e, messages: [...(e.messages || []), message] } : e,
  );
}

/**
 * Marque comme lus, localement, les messages de l'employé.
 *
 * @param {Array} employes collection locale des fiches
 * @param {number} empId fiche dont la direction ouvre le fil
 * @returns {Array} la collection, la fiche mise à jour
 */
export function marqueLusLocalement(employes, empId) {
  return (employes || []).map((e) =>
    e.id === empId
      ? {
          ...e,
          messages: (e.messages || []).map((m) => (m.de === 'employe' ? { ...m, lu: true } : m)),
        }
      : e,
  );
}

/**
 * Nombre de messages de l'employé que la direction n'a pas encore lus.
 *
 * @param {object} [employe] fiche de l'employé
 * @returns {number} le nombre de messages non lus
 */
export function nonLus(employe) {
  return (employe?.messages || []).filter((m) => m.de === 'employe' && !m.lu).length;
}

/**
 * Réponses de la direction que l'employé n'a pas encore lues, depuis son
 * espace : la pastille de « Communication » les compte.
 *
 * @param {object} [employe] fiche de l'employé connecté
 * @returns {number} le nombre de réponses non lues
 */
export function reponsesNonLues(employe) {
  return (employe?.messages || []).filter((m) => m.de !== 'employe' && !m.lu).length;
}

/**
 * Marque comme lues, localement, les réponses de la direction.
 *
 * @param {Array} employes collection locale des fiches
 * @param {number} empId fiche de l'employé qui ouvre sa messagerie
 * @returns {Array} la collection, la fiche mise à jour
 */
export function marqueReponsesLues(employes, empId) {
  return (employes || []).map((e) =>
    e.id === empId
      ? {
          ...e,
          messages: (e.messages || []).map((m) => (m.de !== 'employe' ? { ...m, lu: true } : m)),
        }
      : e,
  );
}
